import { render, staticRenderFns } from "./CarefullySelectedPage.vue?vue&type=template&id=03d1b2ae&scoped=true&"
import script from "./CarefullySelectedPage.vue?vue&type=script&lang=js&"
export * from "./CarefullySelectedPage.vue?vue&type=script&lang=js&"
import style0 from "./CarefullySelectedPage.vue?vue&type=style&index=0&id=03d1b2ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d1b2ae",
  null
  
)

export default component.exports